/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import type { useIsSiteAdminUseIsSiteAdminQuery as useIsSiteAdminUseIsSiteAdminQuery$data } from './__types__/useIsSiteAdminUseIsSiteAdminQuery.ts';
import { getIsSiteAdminFromQuery } from './getIsSiteAdminFromQuery.ts';

export const useIsSiteAdmin = () => {
	const {
		data,
		error,
		loading: isAdminCheckLoading,
	} = useQuery<useIsSiteAdminUseIsSiteAdminQuery$data>(gql`
		query useIsSiteAdminUseIsSiteAdminQuery {
			isSiteAdmin
		}
	`);

	if (error) {
		if (!isUnauthorizedError(error)) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
		}
		markErrorAsHandled(error);
	}

	const isSiteAdmin = getIsSiteAdminFromQuery(data);

	return { isSiteAdmin, isAdminCheckLoading };
};
